import React, { useState } from 'react'
import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'
import { getFreeAccessWhitelist, addFreeAccessEmail, removeFreeAccessEmail } from '../../api'
import Button, { ButtonVariant, ButtonSize } from '../../components/ui/button'
import Input from '../../components/ui/input'
import { useAlerts } from '../../context/alerts'
const FreeAccessWhitelistPage = () => {
  const { addAlert } = useAlerts()
  const [email, setEmail] = useState('')
  const { data: emails = [], mutate } = useSWR('/api/admin/free-access-whitelist', getFreeAccessWhitelist)
  const { trigger: addTrigger, isMutating: isAdding } = useSWRMutation(
    '/api/admin/free-access-whitelist',
    (_key, { arg }: { arg: string }) => addFreeAccessEmail(arg)
  )
  const { trigger: removeTrigger, isMutating: isRemoving } = useSWRMutation(
    '/api/admin/free-access-whitelist',
    (_key, { arg }: { arg: string }) => removeFreeAccessEmail(arg)
  )

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault()
    const value = email.trim().toLowerCase()
    if (!value) {
      addAlert({ type: 'error', message: 'Enter an email address.' })
      return
    }
    try {
      await addTrigger(value)
      addAlert({ type: 'success', message: 'Email added to free access whitelist.' })
      setEmail('')
      mutate()
    } catch (err: any) {
      addAlert({ type: 'error', message: err?.message ?? 'Failed to add email.' })
    }
  }

  const handleRemove = async (em: string) => {
    try {
      await removeTrigger(em)
      addAlert({ type: 'success', message: 'Email removed from whitelist.' })
      mutate()
    } catch (err: any) {
      addAlert({ type: 'error', message: err?.message ?? 'Failed to remove email.' })
    }
  }

  return (
    <div className='container-fluid'>
      <h5 className='mb-3'>Free access whitelist</h5>
      <p className='text-muted small mb-4'>
        Emails listed here can use the tool without subscription or invoice limits.
      </p>

      <form onSubmit={handleAdd} className='row g-2 align-items-end mb-4'>
        <div className='col-auto flex-grow-1' style={{ maxWidth: 320 }}>
          <Input
            type='email'
            placeholder='user@example.com'
            value={email}
            onChange={(e: any) => setEmail(e.target.value)}
            disabled={isAdding}
            label='Add email'
          />
        </div>
        <div className='col-auto'>
          <Button type='submit' variant={ButtonVariant.PRIMARY} disabled={isAdding}>
            {isAdding ? 'Adding…' : 'Add'}
          </Button>
        </div>
      </form>

      <div>
        <h6 className='mb-2'>Whitelisted emails ({emails.length})</h6>
        {emails.length === 0 ? (
          <p className='text-muted small'>No emails on the whitelist yet.</p>
        ) : (
          <ul className='list-group list-group-flush'>
            {emails.map((em: string) => (
              <li
                key={em}
                className='list-group-item d-flex justify-content-between align-items-center'
              >
                <span>{em}</span>
                <Button
                  type='button'
                  variant={ButtonVariant.SECONDARY}
                  size={ButtonSize.SMALL}
                  disabled={isRemoving}
                  onClick={() => handleRemove(em)}
                >
                  Remove
                </Button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default FreeAccessWhitelistPage
